const Authorizations = {
	coBrowsing: ['ReadConversationMessageType_BrowserInfo',
		'ReadConversationMessageType_Navigation',
		'ReadConversationMessageType_DomUpload'],
	video: ['ReadConversationMessageType_Video']
};

export default Authorizations;
